import { atom } from "recoil";

export const alertsState = atom<any[]>({
    key: 'alertsState',
    default: []
})